import React, { useState, useEffect } from "react";
import Login from '../auth/Login'
import './Home.css'
import Logo from '../../images/g2g-logo.png'

const Home = ({routerProps}) => {

    return (
        <div className='home-title'>
            <img style={{width: '300px'}} src={Logo} />
            <h1 style={{color: '#c5baba'}}>Data Application</h1>
        </div>
    )
}

export default Home;